module.exports = __webpack_public_path__ + "./fonts/Archivo-Italic.ttf";